"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eFindCertificatesFilterType = exports.eGetCertificatesFilterType = exports.getPurchasedDate = exports.getAuthorizedUsers = exports.eInsuranceCertificatePurchaseChannel = exports.ActionAllowed = exports.getShipmentCoverageDetails = exports.eInsuranceCertificateStatus = exports.eInsuranceCertificateCancelationReason = void 0;
const utils_1 = require("@loadsure/utils");
const cargo_1 = require("../cargo");
const supportData_1 = require("../supportData");
const commissions_1 = require("../commissions");
const date_fns_1 = require("date-fns");
const insuranceCertificate_class_1 = __importDefault(require("./insuranceCertificate.class"));
var eInsuranceCertificateCancelationReason;
(function (eInsuranceCertificateCancelationReason) {
    eInsuranceCertificateCancelationReason["CANASD"] = "Assured Changed";
    eInsuranceCertificateCancelationReason["CANNLN"] = "Insurance Certificate no longer needed";
    eInsuranceCertificateCancelationReason["CANPIE"] = "Certificate purchased in error";
    eInsuranceCertificateCancelationReason["CANCHP"] = "Cheaper insurance found elsewhere";
    eInsuranceCertificateCancelationReason["CANVAL"] = "Insured value changed";
    eInsuranceCertificateCancelationReason["CANREQ"] = "Insurance was not required by the shipper";
    eInsuranceCertificateCancelationReason["CANCOP"] = "Shipment lost to competition";
    eInsuranceCertificateCancelationReason["CANREP"] = "Origin/Destination/Commodity Changed";
    eInsuranceCertificateCancelationReason["CANOTH"] = "Other";
})(eInsuranceCertificateCancelationReason = exports.eInsuranceCertificateCancelationReason || (exports.eInsuranceCertificateCancelationReason = {}));
var eInsuranceCertificateStatus;
(function (eInsuranceCertificateStatus) {
    eInsuranceCertificateStatus["active"] = "active";
    eInsuranceCertificateStatus["cancelled"] = "cancelled";
    eInsuranceCertificateStatus["paymentPending"] = "paymentPending";
})(eInsuranceCertificateStatus = exports.eInsuranceCertificateStatus || (exports.eInsuranceCertificateStatus = {}));
const getShipmentCoverageDetails = ({ partner, shipment, coverage, underwriting, assured, user }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const masterPolicyId = coverage.policyNumber || partner.masterPolicyId || partner.id;
    const masterPolicyName = partner.name;
    const masterPolicyAddress = partner.address;
    const assuredEmail = assured.email;
    const assuredName = assured.name;
    const assuredAddress = (_b = (_a = assured.address) === null || _a === void 0 ? void 0 : _a.shortAddress) !== null && _b !== void 0 ? _b : "Not specified";
    const purchaser = user;
    const purchaserFirstName = utils_1.firstName(user.name, "Friend");
    const purchaserFullName = (_c = user.name) !== null && _c !== void 0 ? _c : "";
    const purchaserEmail = purchaser.email;
    const { cargo } = shipment;
    const commodity = cargo.commodityNames;
    const descriptionOfGoodsInsured = (_d = cargo.descriptionOfGoodsInsured) !== null && _d !== void 0 ? _d : "";
    const loadType = (_e = cargo_1.TruckloadType.getName(cargo.truckload || cargo.loadType)) !== null && _e !== void 0 ? _e : "Not specified";
    const loadId = shipment.freightId;
    const packaging = cargo.packaging
        ? cargo_1.PackagingType.getName(cargo.packaging)
        : "";
    const { packagingDescription, specificHandlingGuidelines } = cargo;
    const pickupAddress = (_g = (_f = shipment.pickupStop) === null || _f === void 0 ? void 0 : _f.displayName) !== null && _g !== void 0 ? _g : "Not specified";
    const { pickupDate } = shipment;
    const pickupDateISO = pickupDate
        ? date_fns_1.format(date_fns_1.parseISO(pickupDate), "yyyy-MM-dd")
        : "unknown";
    const deliveryAddress = (_j = (_h = shipment.deliveryStop) === null || _h === void 0 ? void 0 : _h.displayName) !== null && _j !== void 0 ? _j : "Not specified";
    const { deliveryDate, poNumber } = shipment;
    const deliveryDateISO = deliveryDate
        ? date_fns_1.format(date_fns_1.parseISO(deliveryDate), "yyyy-MM-dd")
        : "unknown";
    const insuranceProduct = coverage;
    const insuranceProductId = insuranceProduct.id;
    const insuranceProductName = insuranceProduct.name;
    const insuranceType = "Shippers Interest “All Risk” Cargo Insurance";
    const insuranceLimit = utils_1.formatCurrency(insuranceProduct.limit, insuranceProduct.currency);
    const insuranceDeductible = utils_1.formatCurrency(insuranceProduct.deductible, insuranceProduct.currency);
    const insurancePremium = utils_1.formatCurrency(insuranceProduct.premium, insuranceProduct.currency);
    const showInsuranceServiceFee = insuranceProduct.serviceFee > 0;
    const insuranceServiceFee = utils_1.formatCurrency(insuranceProduct.serviceFee, insuranceProduct.currency);
    const insuranceTax = utils_1.formatCurrency(insuranceProduct.tax, insuranceProduct.currency);
    const insuranceTaxesAndFees = utils_1.formatCurrency(insuranceProduct.tax + insuranceProduct.serviceFee, insuranceProduct.currency);
    const insuranceTotalPrice = utils_1.formatCurrency(insuranceProduct.tax +
        insuranceProduct.serviceFee +
        insuranceProduct.premium, insuranceProduct.currency);
    const underwritingCoverageUpdates = {
        premium: utils_1.formatCurrency((_k = underwriting === null || underwriting === void 0 ? void 0 : underwriting.coverage) === null || _k === void 0 ? void 0 : _k.orgPremium, insuranceProduct.currency),
        deductible: utils_1.formatCurrency((_l = underwriting === null || underwriting === void 0 ? void 0 : underwriting.coverage) === null || _l === void 0 ? void 0 : _l.orgDeductible, insuranceProduct.currency)
    };
    const carrier = shipment.carriers[0];
    const equipmentType = supportData_1.allEquipmentTypes()[carrier.equipmentType];
    const { otherEquipmentType } = carrier;
    const insuranceTaxBreakdown = {};
    (_m = coverage.taxBreakdown) === null || _m === void 0 ? void 0 : _m.forEach((tax) => {
        insuranceTaxBreakdown[`${tax.description}`] = utils_1.formatCurrency(tax.value, insuranceProduct.currency);
    });
    const insuranceCommissionBreakdown = Object.fromEntries((_o = coverage.commissionBreakdown) === null || _o === void 0 ? void 0 : _o.map(({ description, type, value }) => [
        description,
        type === commissions_1.eCommissionType.PERCENTAGE
            ? `${value}%`
            : utils_1.formatCurrency(value, insuranceProduct.currency)
    ]));
    return {
        masterPolicyId,
        masterPolicyName,
        masterPolicyAddress: (_p = masterPolicyAddress === null || masterPolicyAddress === void 0 ? void 0 : masterPolicyAddress.shortAddress) !== null && _p !== void 0 ? _p : "",
        assuredEmail,
        assuredName,
        assuredAddress,
        purchaserEmail,
        purchaserFullName,
        purchaserFirstName,
        commodity,
        descriptionOfGoodsInsured,
        loadId,
        poNumber,
        loadType,
        packaging,
        packagingDescription,
        specificHandlingGuidelines,
        pickupAddress,
        pickupDate: pickupDateISO,
        deliveryAddress,
        deliveryDate: deliveryDateISO,
        equipmentType,
        otherEquipmentType,
        insuranceProductId,
        insuranceProductName,
        insuranceType,
        insuranceLimit,
        insuranceDeductible,
        insurancePremium,
        underwritingCoverageUpdates,
        showInsuranceServiceFee,
        insuranceServiceFee,
        insuranceTax,
        insuranceTaxesAndFees,
        insuranceTaxBreakdown,
        insuranceCommissionBreakdown,
        insuranceTotalPrice,
        underwriting
    };
};
exports.getShipmentCoverageDetails = getShipmentCoverageDetails;
class ActionAllowed {
    constructor(error) {
        this.error = error;
        this.allowed = !error;
    }
}
exports.ActionAllowed = ActionAllowed;
var eInsuranceCertificatePurchaseChannel;
(function (eInsuranceCertificatePurchaseChannel) {
    eInsuranceCertificatePurchaseChannel["PORTAL"] = "portal-website";
    eInsuranceCertificatePurchaseChannel["INSURE_LINK_API"] = "api-insureLink";
    eInsuranceCertificatePurchaseChannel["QUOTE_API"] = "api-quote";
    eInsuranceCertificatePurchaseChannel["BATCH_IMPORT"] = "batch-import";
})(eInsuranceCertificatePurchaseChannel = exports.eInsuranceCertificatePurchaseChannel || (exports.eInsuranceCertificatePurchaseChannel = {}));
const getAuthorizedUsers = (data) => {
    var _a, _b, _c;
    const assured = (_a = data === null || data === void 0 ? void 0 : data.assured) !== null && _a !== void 0 ? _a : data.certificateHolder;
    if ((_b = data === null || data === void 0 ? void 0 : data.authorizedUsers) === null || _b === void 0 ? void 0 : _b.length) {
        if (assured === null || assured === void 0 ? void 0 : assured.email) {
            const authorizedUsersSet = new Set(data === null || data === void 0 ? void 0 : data.authorizedUsers);
            if (!authorizedUsersSet.has(assured.email.toLowerCase())) {
                authorizedUsersSet.add(assured.email.toLowerCase());
            }
            return Array.from(authorizedUsersSet);
        }
        return data === null || data === void 0 ? void 0 : data.authorizedUsers;
    }
    const authorizedUsers = new Set();
    if ((_c = data === null || data === void 0 ? void 0 : data.user) === null || _c === void 0 ? void 0 : _c.email) {
        authorizedUsers.add(data.user.email.toLowerCase());
    }
    if (assured === null || assured === void 0 ? void 0 : assured.email) {
        authorizedUsers.add(assured.email.toLowerCase());
    }
    return Array.from(authorizedUsers);
};
exports.getAuthorizedUsers = getAuthorizedUsers;
const getPurchasedDate = (data) => {
    var _a;
    return (_a = data.purchasedDate) !== null && _a !== void 0 ? _a : date_fns_1.formatISO((data.createdDate || data.lastModifiedDate).toDate());
};
exports.getPurchasedDate = getPurchasedDate;
var eGetCertificatesFilterType;
(function (eGetCertificatesFilterType) {
    eGetCertificatesFilterType["ACTIVITY"] = "activity";
    eGetCertificatesFilterType["OWNED"] = "owned";
    eGetCertificatesFilterType["PURCHASED"] = "purchased";
    eGetCertificatesFilterType["FIND_CERTIFICATE"] = "find_certificate";
})(eGetCertificatesFilterType = exports.eGetCertificatesFilterType || (exports.eGetCertificatesFilterType = {}));
var eFindCertificatesFilterType;
(function (eFindCertificatesFilterType) {
    eFindCertificatesFilterType["CERTIFICATE_NUMBER"] = "certificateNumber";
    eFindCertificatesFilterType["SHIPMENT_FREIGHT_ID"] = "shipment.freightId";
    eFindCertificatesFilterType["PURCHASED_DATE"] = "purchasedDate";
    eFindCertificatesFilterType["SHIPMENT_PICKUP_DATE"] = "shipment.pickupDate";
    eFindCertificatesFilterType["SHIPMENT_DELIVERY_DATE"] = "shipment.deliveryDate";
})(eFindCertificatesFilterType = exports.eFindCertificatesFilterType || (exports.eFindCertificatesFilterType = {}));
exports.default = insuranceCertificate_class_1.default;
//# sourceMappingURL=index.js.map